import { useIdleTimer } from 'react-idle-timer';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import SidebarComponent from '../../components/Sidebar';
import { ReactComponent as Home } from '../../assets/images/home.svg';
import { ReactComponent as Admins } from '../../assets/images/admins.svg';
import { ReactComponent as Partners } from '../../assets/images/nav-partners.svg';
import { ReactComponent as Requests } from '../../assets/images/requests.svg';
import { ReactComponent as Content } from '../../assets/images/content.svg';
import { ReactComponent as ActiveHome } from '../../assets/images/active-home.svg';
import { ReactComponent as ActiveAdmins } from '../../assets/images/active-admins.svg';
import { ReactComponent as ActivePartners } from '../../assets/images/active-partners.svg';
import { ReactComponent as ActiveRequests } from '../../assets/images/active-requests.svg';
import { ReactComponent as ActiveContent } from '../../assets/images/active-content.svg';
import Popup from '../../components/common/Popup/Popup';
import { clearLocalStorage } from '../../utils/token';
import { getPromptTimeOut, getSessionAlertTimeOut } from '../../config';
import styles from './styles';

const items = [
    { id: 1, Icon: Home, ActiveIcon: ActiveHome, text: 'Home', url: '/dashboard' },
    { id: 2, text: 'divider' },
    { id: 3, text: 'Users' },
    { id: 4, Icon: Admins, ActiveIcon: ActiveAdmins, text: 'Admins', url: '/admin-management' },
    { id: 5, Icon: Partners, ActiveIcon: ActivePartners, text: 'Partners', url: '/partner-member' },
    { id: 6, Icon: Requests, ActiveIcon: ActiveRequests, text: 'New Member Requests', url: '/new-member-request' },
    { id: 7, text: 'divider' },
    { id: 8, Icon: Content, ActiveIcon: ActiveContent, text: 'Content Management', url: '/content-management' },
];

const Sidebar = () => {
    const [open, setPopUp] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const navigate = useNavigate();
    const onPrompt = () => {
        // Fire a Modal Prompt
        setPopUp(true);
    };

    const onIdle = () => {
        // Close Modal Prompt
        // Do some idle action like log out your user
        clearLocalStorage();
        setPopUp(false);
        navigate('/');
    };

    const { reset } = useIdleTimer({
        onPrompt,
        onIdle,
        timeout: Number(getSessionAlertTimeOut()),
        promptTimeout: Number(getPromptTimeOut()),
        element: document,
        emitOnAllTabs: true,
    });

    const stayLoggedInClick = () => {
        reset();
        setPopUp(false);
    };

    const handleLogout = () => {
        setConfirm(true);
    };

    const handleCancel = () => {
        setConfirm(false);
    };

    const handleSignOut = () => {
        clearLocalStorage();
        setConfirm(false);
        navigate('/');
    };

    return (
        <>
            <Popup
                id="timeout_alert"
                open={open}
                title="Timeout Alert"
                textAlign="left"
                handleClose={() => null}
                description={<>You are about to be logged out. Please click below to stay logged in.</>}
            >
                <Button
                    id="stayLoggedIn"
                    variant="contained"
                    sx={styles.sessionAlertPopUp}
                    fullWidth
                    onClick={stayLoggedInClick}
                >
                    Stay Logged In
                </Button>
            </Popup>
            <Popup
                id="signOut"
                open={confirm}
                title="Sign Out"
                textAlign="left"
                handleClose={() => null}
                description={<>Are you sure you want to sign out from Diathrive Admin Portal? </>}
            >
                <>
                    <Button id="cancel" variant="outlined" sx={styles.cancel} onClick={handleCancel}>
                        Cancel
                    </Button>
                    <Button id="signOut" variant="contained" sx={styles.signOut} onClick={handleSignOut}>
                        Sign out
                    </Button>
                </>
            </Popup>
            <SidebarComponent items={items} handleLogout={handleLogout} />
        </>
    );
};

export default Sidebar;
